import React from "react";
import LegalShell from "./components/LegalShell";
import { useLang } from "./LangContext";

// All [PLATZHALTER] markers must be replaced or verified before going live.
export default function PrivacyPage() {
  const { t } = useLang();
  return (
    <LegalShell>
      <h1>{t.privacyTitle}</h1>

      <h2>1. Verantwortlicher</h2>
      <p>
        Verantwortlich für die Verarbeitung personenbezogener Daten auf dieser Website ist:
      </p>
      <address>
        <span className="legal-placeholder">[Vorname Nachname]</span><br />
        <span className="legal-placeholder">[Straße Hausnummer, PLZ Ort]</span><br />
        E-Mail: <span className="legal-placeholder">[kontakt@beispiel.de]</span>
      </address>

      <h2>2. Welche Daten wir verarbeiten</h2>
      <p>Wir verarbeiten folgende personenbezogene Daten:</p>
      <ul>
        <li>
          <strong>Kundendaten (Buchungsvorgang):</strong> Name, E-Mail-Adresse sowie optionale
          Beschreibungsfelder, die Sie beim Buchen eines Termins angeben.
        </li>
        <li>
          <strong>Künstler-Kontodaten:</strong> Vor- und Nachname, E-Mail-Adresse sowie ein
          Passwort-Hash für registrierte Anbieter (Künstler/Dienstleister).
        </li>
        <li>
          <strong>Technische Sitzungsdaten:</strong> Beim Login werden ein kurzlebiger
          Zugriffstoken und ein Aktualisierungstoken gesetzt. Der Aktualisierungstoken wird als
          httpOnly-Cookie übertragen und serverseitig (gehashter Wert) gespeichert.
        </li>
        <li>
          <strong>Lokaler Browser-Speicher:</strong> Sprachpräferenz und Farbschema werden
          im localStorage Ihres Browsers gespeichert; diese Daten verlassen Ihr Gerät nicht.
        </li>
      </ul>

      <h2>3. Zweck und Rechtsgrundlage</h2>
      <ul>
        <li>
          Terminbuchungen werden auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO verarbeitet
          (Vertragsanbahnung/-erfüllung).
        </li>
        <li>
          Kontozugänge für Anbieter werden auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO
          verarbeitet.
        </li>
        <li>
          Transaktions-E-Mails (Buchungsbestätigung, Terminannahme/-absage) werden zum
          Zweck der Vertragserfüllung gemäß Art. 6 Abs. 1 lit. b DSGVO versandt.
        </li>
      </ul>

      <h2>4. Speicherdauer und Löschung</h2>
      <p>
        Kundendaten (Name, E-Mail) in Buchungseinträgen werden auf Anfrage des Anbieters
        anonymisiert. Anbieterkonten und alle zugehörigen Daten können auf Anfrage vollständig
        und dauerhaft gelöscht werden.
      </p>
      <p>
        Aktualisierungstoken laufen nach 7 Tagen automatisch ab und werden bei Abmeldung
        sofort widerrufen.
      </p>

      <h2>5. Weitergabe an Dritte</h2>
      <p>
        E-Mails werden über{" "}
        <span className="legal-placeholder">[Name des E-Mail-Dienstleisters, z. B. Mailgun / Postmark / SendGrid]</span>{" "}
        versandt. Dabei werden Name und E-Mail-Adresse des Empfängers übermittelt. Es erfolgt
        keine weitere Weitergabe an Dritte.
      </p>
      <p>
        Anbieter können optional ihr Google-Konto verbinden, um Termine im Google Kalender
        zu synchronisieren. In diesem Fall werden Termindaten (Datum, Uhrzeit, Kundenname)
        an die Google Calendar API übermittelt. Rechtsgrundlage ist die ausdrückliche
        Einwilligung des Anbieters (Art. 6 Abs. 1 lit. a DSGVO).
      </p>

      <h2>6. Ihre Rechte</h2>
      <p>Sie haben gegenüber uns folgende Rechte hinsichtlich Ihrer personenbezogenen Daten:</p>
      <ul>
        <li>Recht auf Auskunft (Art. 15 DSGVO)</li>
        <li>Recht auf Berichtigung (Art. 16 DSGVO)</li>
        <li>Recht auf Löschung (Art. 17 DSGVO)</li>
        <li>Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
        <li>Recht auf Datenübertragbarkeit (Art. 20 DSGVO)</li>
        <li>Recht auf Widerspruch gegen die Verarbeitung (Art. 21 DSGVO)</li>
      </ul>
      <p>
        Zur Ausübung Ihrer Rechte wenden Sie sich bitte an:{" "}
        <span className="legal-placeholder">[kontakt@beispiel.de]</span>
      </p>

      <h2>7. Beschwerderecht</h2>
      <p>
        Sie haben das Recht, sich bei einer Datenschutz-Aufsichtsbehörde über die Verarbeitung
        Ihrer personenbezogenen Daten zu beschweren. Die zuständige Behörde richtet sich nach
        Ihrem Wohnsitz.
      </p>
    </LegalShell>
  );
}
